// extracted by extract-css-chunks-webpack-plugin
module.exports = {"body":"body___nvX4w"};